import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, FormGroup, Input } from 'reactstrap';
import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { changeIndexToNepali, colorScale } from '../../utils'
import Api from '../../services/api';
import './style.css';
import { Helmet } from 'react-helmet';
import { BounceLoader } from 'react-spinners';
import { Bar, BarChart, CartesianGrid, Legend, PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                categories: []
            },
            activeTab: 0,
            activeArea: null,
            orgData: null,
            nepalMap: null,
            provinceMap: null,
            districtMap: null,
            localMap: null,
            nepalData: null,
            provinceData: null,
            districtData: null,
            localData: [],
            activeData: null,
            categories: [],
            subCategories: [],
            totalLgFilled: 0,
            isLoading: true,
            fy: null,
            fyId: 0,
            fyList: [],
            provinceId: 0,
            provinceList: [],
            districtId: 0,
            districtList: [],
            palikaId: 0,
            palikaList: [],
            homeCategories: null,
            homeStat: [],
            hoemSubCategories: null,
            isChartMounted: false,
        };

        this.toggle = this.toggle.bind(this);
        this._updateData = this._updateData.bind(this);
        this._redirect = this._redirect.bind(this);
        this.printRef = React.createRef();
        this.printBarRef = React.createRef();
        this.printSubCatRef = React.createRef();

    }

    toggle = tabIndex => {
        if (this.state.activeTab !== tabIndex) {
            this.setState({
                activeTab: tabIndex
            });
        }
    };

    async componentDidMount() {
        let localData = this.props.fiscal_year_id
        let fiscal = localStorage.getItem('fiscalYear');

        await this.setState({
            fyId: localData ? localData : fiscal
        })
        // this._getNepalProvinceData();
        // this._getLocalData();
        this._getHomeData();
        this._getProvinceList();
        this._getTotalData();
        this._getFiscalyear();
    }

    _handleDownloadImage = async () => {
        const element = this.printRef.current;
        const canvas = await html2canvas(element);

        const data = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");

        if (typeof link.download === "string") {
            link.href = data;
            link.download = "RadarChart.jpg";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(data);
        }
    };

    _handleDownloadBarImage = async () => {

        const element = this.printBarRef.current;
        const canvas = await html2canvas(element);

        const data = canvas.toDataURL('image/jpeg');
        const link = document.createElement('a');

        if (typeof link.download === 'string') {
            link.href = data;
            link.download = 'RadarChart.jpg';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(data);
        }


    };



    // _handleDownloadBarImage = () => {
    //     const svg = document.querySelector("svg");
    //     const svgData = new XMLSerializer().serializeToString(svg);
    //     const img = new Image();
    //     const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    //     const imgSrc = URL.createObjectURL(svgBlob);
    //     img.onload = () => {
    //         const a = document.createElement("a");
    //         a.download = "chart.png";
    //         a.href = imgSrc;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         URL.revokeObjectURL(imgSrc);
    //     };
    //     img.src = imgSrc;
    // };



    _handleDownloadRadarImage = async () => {
        const element = this.printSubCatRef.current;
        const canvas = await html2canvas(element);

        const data = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");

        if (typeof link.download === "string") {
            link.href = data;
            link.download = "RadarChartII.jpg";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(data);
        }
    };
    _getTotalData = async () => {
        // const data = await Api.getReportData({fy });
        this.setState({ totalLgFilled: changeIndexToNepali(1) });
    }


    _getHomeData = async () => {
        const { fiscal_year_id } = this.props;
        let homeRes = await Api.getHomeData({ fiscal_year_id: this.state.fyId });
        let nullData = {
            "name": "",
            "score": "-",
            "totalMarks": 0,
            "categories": {
                "1": "0",
                "2": "0",
                "3": "0",
                "4": "0",
                "5": "0",
                "6": "0",
                "7": "0",
                "8": "0",
                "9": "0",
                "10": "0"
            },
            "subCategories": {
                "1": "0",
                "2": "0",
                "3": "0"
            }
        };
        if (homeRes && homeRes.response) {
            this.setState({
                homeSubCategories: homeRes.response.subCategories,
                homeStat: homeRes.response.stat,
                homeCategories: homeRes.response.categories,
                nullData,
                isLoading: false,
            });
        }
    }

    _getHomeDataFilter = async (params) => {
        let homeRes = await Api.getHomeData(params);
        let nullData = {
            "name": "",
            "score": "-",
            "totalMarks": 0,
            "categories": {
                "1": "0",
                "2": "0",
                "3": "0",
                "4": "0",
                "5": "0",
                "6": "0",
                "7": "0",
                "8": "0",
                "9": "0",
                "10": "0"
            },
            "subCategories": {
                "1": "0",
                "2": "0",
                "3": "0"
            }
        };
        this.setState({
            homeSubCategories: homeRes.response.subCategories,
            homeStat: homeRes.response.stat,
            homeCategories: homeRes.response.categories,
            nullData,
            isLoading: false,
        });
    }

    _getProvinceList = async () => {
        let provinceListRes = await Api.getProvinceList();

        this.setState({
            provinceList: provinceListRes.response,
        });
    }

    _handleProvinceChange = async (e) => {
        let provinceId = e.target.value
        this.setState({
            provinceId: provinceId,
            districtId: 0,
            palikaId: 0,
            palikaList: [],
        });
        this._getDistrictList(provinceId);

        // this._updateData(provinceName, 'province', provinceName);
        this._getHomeDataFilter({ province_id: provinceId, fiscal_year_id: this.state.fyId });
    }

    _getDistrictList = async (provinceId) => {
        let districtListRes = await Api.getDistrictList(provinceId);

        this.setState({
            districtList: districtListRes.response,
        });
    }

    _handleDistrictChange = async (e) => {
        let districtId = e.target.value
        this.setState({
            districtId: districtId,
            palikaId: 0,
        });
        this._getPalikaList(districtId);
        await this._getHomeDataFilter({
            district_id: districtId,
            fiscal_year_id: this.state.fyId,
        });
    }

    _getPalikaList = async (districtId) => {
        let palikaListRes = await Api.getPalikaList(districtId);
        this.setState({
            palikaList: palikaListRes.response,
        });
    }

    _handlePalikaChange = async (e) => {
        let palikaId = e.target.value
        this.setState({
            palikaId: palikaId,
        });

        const palika = await this.state.palikaList.find((palika) => palika.id.toString() === palikaId.toString())

        // if (palika && palika.gnid) {
        //     this.props.history.push({
        //         pathname: `/details`,
        //         search: `gnid=${palika.gnid}`,
        //     });
        // }

        if (palika && palika.gnid) {
            this.props.history.push(
                {
                    pathname: `/details/local/${palika.gnid}`
                }
            );
        }
    }

    _handleFiscalYearChange = async (e) => {
        let fiscalYearId = e.target.value
        this.setState({
            fyId: fiscalYearId,
            provinceId: 0,
            districtId: 0,
            districtList: [],
            palikaId: 0,
            palikaList: [],
            isLoading: true
        });
        localStorage.setItem('fiscalYear', fiscalYearId);
        await this._getHomeDataFilter({ fiscal_year_id: fiscalYearId });
        this.setState({
            isLoading: false
        });
    }

    _updateData(objectId, type, layerName) {
        const { provinceData, localData, nepalData, nullData, districtData } = this.state;
        let data;
        switch (type) {
            case 'province':
                let provinceFound = provinceData.find(p => p.name == objectId);
                if (provinceFound) {
                    data = provinceFound;
                } else {
                    data = nullData;
                    data.name = layerName
                }
                this.setState({ activeData: data });
                // this.loadMap();
                return;
            case 'district':
                let districtFound = districtData.find(d => d.name == objectId);
                if (districtFound) {
                    data = districtFound;
                } else {
                    data = nullData;
                    data.name = layerName
                }
                this.setState({ activeData: data });
                return;
            case 'local':
                let lgFound = localData.find(lg => lg.gnid == objectId);
                if (lgFound) {
                    data = lgFound;
                } else {
                    data = nullData;
                    data.name = layerName
                }
                this.setState({ activeData: data });
                return;
            default:
                this.setState({ activeData: nepalData });
                return;
        }
    }

    _redirect(objectId, type) {
        const { history } = this.props;
        const { localData, provinceData } = this.state;
        let provinceFound = provinceData.find(p => p.name == objectId);
        let lgFound = localData.find(lg => lg.gnid == objectId);

        if (type === 'local' && lgFound) {
            history.push(
                {
                    pathname: `/details/${type}/${objectId}`
                }
            );
        } else if (type === 'district') {
            return;
        } else if (type === 'province') {
            return;
        }

    }

    _onLoginClick() {
        return (
            <Redirect to={{
                pathname: '/login',
                state: { from: this.props.location }
            }} />
        );
    }

    _renderCategoriesList() {
        const { homeCategories } = this.state;
        if (!homeCategories) return;
        let content = [];
        homeCategories.map(category => {
            let categoryName = (category.name).toString();
            content.push(<div className='main-list' key={categoryName}  >
                <span className='dash-cat-name'>
                    <img src={category.image} className="cat-icon" alt="cat-icon" />
                    <div className="name">{category.name}</div>
                    <CircularProgressbar
                        percentage={category.percent_score}
                        text={`${changeIndexToNepali(category.percent_score)}`}
                        styles={{
                            path: { stroke: colorScale(category.percent_score) },
                            text: { fill: colorScale(category.percent_score), fontSize: '28px' },
                        }}
                    />
                </span>
            </div>);
        })
        return content;
    }

    _getFiscalyear = async () => {
        let fyList = await Api.getFyList();
        this.setState({ fyList: fyList.response });
    }





    render() {
        const { history } = this.props;
        const { activeTab, localMap, districtMap, provinceMap, homeStat, homeSubCategories, homeCategories, fyId, fyList, provinceId, provinceList, districtList, districtId, palikaList, palikaId } = this.state;
        const isJsonLoaded = (activeTab === 'local') ? !!localMap : (activeTab === 'district') ? !!districtMap : !!provinceMap;
        if (!homeCategories) {
            return (
                <div className="loading">Loading...</div>
            );
        }

        return (
            <section className="home">
                <Helmet>
                    <title>GESI Nepal - Home</title>
                </Helmet>

                {/* Input Section */}
                <Row>
                    <Col sm={3}>
                        <span className="breadcrumb-text" style={{ fontSize: '18px', fontWeight: 'bold', color: 'black' }}>
                            गृह पृष्ठ
                            |</span>
                        <span className="breadcrumb-text" style={{ marginLeft: '5px' }}>
                            नक्शा
                        </span>
                    </Col>
                    <Col sm={3}>
                        <FormGroup>
                            <Input type="select" name="fselect" id="fiscalYearSelect" value={fyId} onChange={(e) => this._handleFiscalYearChange(e)}>
                                <option value={0} disabled selected>आर्थिक वर्ष चयन गार्नुहोस</option>
                                {
                                    fyList.length > 0 &&
                                    fyList.map((fy, index) => {
                                        return (
                                            <option key={fy.id} value={fy.id} >आर्थिक वर्ष {fy.name}</option>
                                        );
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}>
                        <FormGroup>
                            <Input type="select" placeholder="प्रदेश चयन गर्नुहोस" name="provinceId" id="provinceId" value={provinceId} onChange={(e) => this._handleProvinceChange(e)}>
                                <option value={0} disabled selected>प्रदेश चयन गर्नुहोस</option>
                                {
                                    provinceList.length > 0 &&
                                    provinceList.map((province, index) => {
                                        return (
                                            <option key={province.id} value={province.id} >{province.name}</option>
                                        );
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}>
                        <FormGroup>
                            <Input type="select" placeholder="जिल्ला चयन गर्नुहोस" name="districtId" id="districtId" value={districtId} onChange={(e) => this._handleDistrictChange(e)}>
                                <option value={0} disabled selected>जिल्ला चयन गर्नुहोस</option>
                                {
                                    districtList.length > 0 &&
                                    districtList.map((district, index) => {
                                        return (
                                            <option key={district.id} value={district.id} >{district.name}</option>
                                        );
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}>
                        <FormGroup>
                            <Input type="select" placeholder="पालिका चयन गर्नुहोस" name="palikaId" id="palikaId" value={palikaId} onChange={(e) => this._handlePalikaChange(e)}>
                                <option value={0} disabled selected>पालिका चयन गर्नुहोस</option>
                                {
                                    palikaList.length > 0 &&
                                    palikaList.map((palika, index) => {
                                        return (
                                            <option key={palika.id} value={palika.id} >{palika.name}</option>
                                        );
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>

                {this.state.isLoading ? (<div className="w-100 d-flex justify-content-center my-5"> <BounceLoader color='#1f8cd5' /></div>) : (
                    <div>
                        <Row>
                            {/* <Col sm="3">
                                <div className="home-list">
                                    <h5 className="sub-heading">स्व-मूल्याङ्कन विषयक्षेत्रहरु</h5>
                                    {
                                        this._renderCategoriesList()
                                    }
                                </div>
                            </Col> */}
                            <Col sm="9">
                                {isJsonLoaded &&
                                    <div className="map-wrapper">
                                        {/* <MapBox
                                            provinceId={provinceId || ''}
                                            districtId={districtId || ''}
                                            palikaId={palikaId || ''}
                                            handleProvinceChange={this._handleProvinceChange}
                                            handleDistrictChange={this._handleDistrictChange}
                                            handlePalikaChange={this._handlePalikaChange} /> */}
                                    </div>
                                }
                            </Col>

                            <Col></Col>
                        </Row>

                        <Row>
                            <div className="d-flex flex-wrap justify-content-between col my-4">

                                {homeStat[0] && homeStat[0].items.map((m, index) => (

                                    <div className='bg-white border rounded col-12 col-md-2 d-flex align-items-center p-3'>

                                        <img src={require(`../../assets/images/${(index + 1) * 10}.svg`)} className='cat-icon' alt="cat-icons"></img>

                                        <div className='d-flex flex-column'>
                                            <h5 style={{ color: colorScale(100) }}>{m.name}</h5>
                                            <p className='mb-0 text-start'>{changeIndexToNepali(m.count)}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>
                        </Row>
                        <Row>
                            <Col sm="3">
                                <div className="home-list" style={{ height: "100%" }}>
                                    <h5 className="sub-heading">स्व-मूल्याङ्कन विषयक्षेत्रहरु</h5>
                                    {
                                        this._renderCategoriesList()
                                    }
                                </div>

                            </Col>
                            <Col sm="9" >
                                <div className='home-list' >
                                    {console.log('homeCategories', homeCategories)}
                                    <div>
                                        <button type="button"
                                            className="btn btn-primary btn-sm" onClick={this._handleDownloadImage}>डाउनलोड</button>
                                    </div>
                                    <div ref={this.printRef}>
                                        <ResponsiveContainer width="100%" height={400}>
                                            <RadarChart outerRadius={140} data={homeCategories}>
                                                <PolarGrid />
                                                <PolarAngleAxis dataKey="name" />
                                                <PolarRadiusAxis angle={30} domain={[0, 20]} />
                                                <Radar name="पुर्णाक" dataKey="total_marks" stroke="#82ca9d" strokeWidth="3" fill="#82ca9d" fillOpacity={0} />
                                                <Radar name="औसत" dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                                                <Legend />
                                            </RadarChart>
                                        </ResponsiveContainer>
                                    </div>



                                </div>

                            </Col>
                        </Row>

                        {/* bar Section */}
                        <Row >
                            <Col sm="3">
                                <div className='home-list my-4' style={{ height: 480 }}  >
                                    <p className='sub-heading'>लैससास परीक्षण नतिजा</p>
                                    <Nav tabs vertical pills style={{ border: "none" }} >
                                        {homeCategories.map((tabData, index) => (
                                            <NavItem key={index} style={{ width: "100%" }}>
                                                <NavLink
                                                    className={this.state.activeTab === index ? "active" : ""}
                                                    onClick={() => {
                                                        this.toggle(index);
                                                    }}
                                                >
                                                    {tabData.name}
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                </div>

                            </Col>
                            <Col sm="9">
                                <div className='home-list my-4' >
                                    <TabContent activeTab={this.state.activeTab}>
                                        {homeCategories.map((tabData, index) => (
                                            <TabPane key={index} tabId={index}>
                                                <Row>
                                                    <Col sm="12">
                                                        <div ref={this.printBarRef} >

                                                            <ResponsiveContainer ResponsiveContainer width="100%" height={450} >
                                                                <BarChart data={tabData.subcategories} >
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="name" />
                                                                    <YAxis />
                                                                    <Tooltip />
                                                                    <Legend />
                                                                    <Bar name="प्राप्ताङ्क" dataKey="avg_score" fill="#8884d8" />
                                                                    <Bar name="पुर्णाक" dataKey="full_mark" fill="#82ca9d" />
                                                                </BarChart>
                                                            </ResponsiveContainer>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        ))}
                                    </TabContent>
                                </div>
                            </Col>
                        </Row >
                        <Row>
                            <Col sm="12">

                                <div className='home-list my-4' >
                                    <div onClick={this._handleDownloadRadarImage}><button className='btn btn-primary'>डाउनलोड</button></div>
                                    <div ref={this.printSubCatRef}>
                                        <p className='sub-heading d-flex justify-content-center'>लैङ्गिक समानता तथा सामाजिक समावेशीकरणको अवस्था</p>
                                        <ResponsiveContainer width="100%" height={950}>
                                            <RadarChart outerRadius={350} data={homeSubCategories}>
                                                <PolarGrid />
                                                <PolarAngleAxis dataKey="name" />
                                                <PolarRadiusAxis angle={30} domain={[0, 8]} />
                                                <Radar name="प्राप्ताङ्क" dataKey="avg_score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                                                <Radar name="पुर्णाक" dataKey="full_mark" stroke="#82ca9d" strokeWidth={3} fill="#82ca9d" fillOpacity={0} />
                                                <Legend />
                                            </RadarChart>
                                        </ResponsiveContainer>
                                    </div>


                                </div>
                            </Col>
                        </Row>
                    </div >
                )
                }
            </section>



        );
    }
}
const mapStateToProps = ({ auth }) => ({
    fiscal_year_id: auth.login.fiscal_year_id
});


export default connect(mapStateToProps)(Home);
